<template>
    <div class="page" @keydown.enter="login">

        <div class="login_panel fx-col  fx-c_stretch">
            <div class="title">欢迎登录</div>
            <div class="fx-col fx-c_center ">
                <div class="login_info fx fx-center">
                    <img src="@/assets/imgs/login/login_name.png" class="login_icon" autofocus="true">
                    <input type="text" placeholder="请输入用户名" v-model="name" class="fx-g1">
                </div>
                <div class="login_info  fx fx-center">
                    <img src="@/assets/imgs/login/login_pwd.png" class="login_icon">
                    <input type="password" placeholder="请输入密码" v-model="password" class="fx-g1">
                </div>
                <div class="login_btn" @click="login">
                    <span class="line"></span>
                    <img src="@/assets/imgs/login/login_btn.png" id="login_btn">
                </div>
            </div>


        </div>
    </div>
</template>

<style scoped>
    .page {
        width: 100%;
        height: 100%;
        background-image: url("../assets/imgs/login/login_bg.png");
        background-size: cover;
        background-position: center;
        background-color: #2B3636;
        background-repeat: no-repeat;
    }

    .login_panel {
        width: 510px;
        height: 550px;
        background: white;
        position: absolute;
        top: 50%;
        margin-top: -250px;
        right: 15%;
    }

    .login_panel .title {
        color: var(--primary);
        font-size: 26px;
        text-align: center;
        margin-top: 50px;
        margin-bottom: 80px;
    }

    .login_panel .login_info {
        width: 400px;
        height: 55px;
        border: 1px solid var(--border);
        border-radius: 30px;
        margin-bottom: 30px;
        box-sizing: border-box;
    }

    .login_panel .login_icon {
        width: 30px;
        margin: 0 22px;
    }

    .login_panel input {
        border: none;
        outline: none;
        margin-right: 1rem;
        font-size: 20px;
    }

    .login_panel .login_btn {
        text-align: center;
        position: relative;
        width: 100%;
        margin-top: 50px;
    }

    .login_panel .login_btn .line {
        display: inline-block;
        width: 100%;
        height: 0;
        border-bottom: 1px dashed #8BC3DF;
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 1;
        margin-top: -10px;
    }

    .login_panel .login_btn img {
        position: relative;
        z-index: 2;
        cursor: pointer;
        user-select: none;
    }
</style>


<script>
    // // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import {mapState, mapMutations} from "vuex";


    export default {
        components: {
            // HelloWorld
        },
        props: [
            "attr"
        ],
        data() {
            return {
                name: "",
                password: "",
            }

        },

        computed: {
            ...mapState({})
        },

        methods: {
            ...mapMutations([
                "setUser",
                "reLogin",
            ]),
            login() {
                if (this.name && this.password) {
                    this.$ajaxPost("/login", {
                        name: this.name,
                        password: this.password,
                    }, (data) => {
                        if (!data.result.user.isStaff ) {
                            this.$showError("您已不是员工，无法登录", 1500, ()=> {
                                this.reLogin();
                            })
                            return;
                        }
                        this.setUser(data.result.user);
                        document.getElementById("titleName").innerHTML = data.result.user.institutionName;
                        window.updateLocalToken(data.result.token);

                        this.processResourceLoad(data.result.resourceLoadConfig)
                    })
                } else {
                    this.$message.error("请输入用户名密码");
                }
            },
            /**
             * 检测本地服务器是否可访问，可访问，那么视频等资源从本地获取
             * @param config
             */
            processResourceLoad(config) {

                localStorage.setItem("scratchUrl", "");

                if (!config || !config.url) {
                    //未配置的话，就不用让getScratchUrl() 等了
                    localStorage.setItem("checkLocalTime", new Date().getTime() - 5000);
                    return;
                }
                //记录检测本地服务器是否可用的时间
                localStorage.setItem("checkLocalTime", new Date().getTime());
                console.debug("开始测试本地服务器是否可访问");
                let url = config.url;
                if (url.endsWith("/") == false) url += "/";
                this.$ajaxGet(`${url}test`, res => {
                    console.debug("本地服务器访问成功，将该校区进行标记，修改资源的访问路径");
                    this.updateLocalResourceState(true)
                }, null, () => {
                    console.error("本地服务器访问失败，将该校区进行标记");
                    this.updateLocalResourceState(false)
                }, {timeout: 3000})


            },

            updateLocalResourceState(success) {
                this.$ajaxGet(`/mediaResource/updateLocalResourceState/${success}`)
            }

        },

        created() {
            let url = window.location.href;
            let info = url.split("?")[1];
            let param = new URLSearchParams(info);
            let randomKey = param.get("randomKey");
            if(randomKey){
                this.$ajaxPost("/imitateLogin/" + randomKey, {}, (data) => {
                    this.setUser(data.result.user);
                    document.getElementById("titleName").innerHTML = data.result.user.institutionName;
                    window.updateLocalToken(data.result.token);
                    window.location.href = url.split("?")[0];
                    this.processResourceLoad(data.result.resourceLoadConfig)
                })
            }
        }
    }
</script>
